<div class="custom-modal-layout">
    <div class="modal-header">
        <div class="icon">
            <img src="icons/plus-circle.svg" alt="Email Icon" />
        </div>
        <span class="title">Novo Curso</span>
        <p-button icon="pi pi-times" class="close-btn" [rounded]="true" [text]="true" (onClick)="cancel()" />
    </div>
    <form [formGroup]="cursoForm" (ngSubmit)="save()">
        <div class="p-fluid grid">
            <div class="field col-12">
                <label for="designacao">Nome do curso</label>
                <input id="designacao" type="text" class="w-full" pInputText formControlName="designacao"
                    placeholder="Nome do curso" />
                <div *ngIf="cursoForm.get('designacao')?.invalid && cursoForm.get('designacao')?.touched" class="error-message">
                    Nome do curso é obrigatório
                </div>
            </div>
<!--
            <div class="field col-6">
                <label for="sigla">Sigla do curso</label>
                <input id="sigla" type="text" class="w-full" pInputText formControlName="sigla"
                    placeholder="Sigla" />
            </div>

            <div class="field col-6">
                <label for="codigo">Código do curso</label>
                <input id="codigo" type="text" class="w-full" pInputText formControlName="codigo"
                    placeholder="Código do curso" />
            </div> -->

            <div class="field col-6">
                <label for="areaFormacao">Área de Conhecimento</label>
                <p-select id="areaFormacao" class="w-full" optionLabel="designacao" optionValue="id" [options]="areaFormacaoList" placeholder="Seleccione uma Área de Conhecimento"
                formControlName="areaFormacaoID" appendTo="body" ></p-select>
                <div *ngIf="cursoForm.get('areaFormacaoID')?.invalid && cursoForm.get('areaFormacaoID')?.touched" class="error-message">
                    Área de Formação do curso é obrigatório
                </div>
            </div>

            <div class="field col-6">
                <label for="categoriaInstituicaoEnsinoID">Categoria do curso</label>
                <p-select id="categoriaInstituicaoEnsinoID" class="w-full" optionLabel="designacao" optionValue="id" [options]="categoriaInstituicaoEnsinoList" placeholder="Seleccione a categoria"
                formControlName="categoriaInstituicaoEnsinoID" appendTo="body" ></p-select>
                <div *ngIf="cursoForm.get('categoriaInstituicaoEnsinoID')?.invalid && cursoForm.get('categoriaInstituicaoEnsinoID')?.touched" class="error-message">
                  Categoria do curso é obrigatório
                </div>
            </div>

            <div class="field col-12">
                <label for="nivelAcademico">Nível Académico</label>
                <p-select id="nivelAcademico" class="w-full" optionLabel="designacao" optionValue="id" [options]="nivelAcademicoOptions" placeholder="Seleccione o nível Académico" appendTo="body"
                formControlName="nivelAcademico"></p-select>
                <div *ngIf="cursoForm.get('nivelAcademico')?.invalid && cursoForm.get('nivelAcademico')?.touched" class="error-message">
                  Nivel académico do curso é obrigatório
                </div>
            </div>

        </div>

        <div class="modal-footer">
            <button pButton type="button" label="Cancelar" class="p-button-outlined" (click)="cancel()"></button>
            <button pButton type="submit" label="Adicionar" class="p-button-primary"></button>
        </div>
    </form>
</div>


<!--

<div class="custom-modal-layout">
    <div class="modal-header">
        <div class="icon">
            <img src="icons/plus-circle.svg" alt="Email Icon" />
        </div>
        <span class="title">Novo Curso</span>
        <p-button icon="pi pi-times" class="close-btn" [rounded]="true" [text]="true" (onClick)="cancel()" />
    </div>
    <form [formGroup]="cursoForm" (ngSubmit)="save()">
        <div class="p-fluid grid">
            <div class="field col-12">
                <label for="designacao">Nome do curso</label>
                <input id="designacao" type="text" class="w-full" pInputText formControlName="designacao"
                    placeholder="Nome do curso" />
            </div>
            <div class="field col-6">
                <label for="sigla">Sigla do curso</label>
                <input id="sigla" type="text" class="w-full" pInputText formControlName="sigla"
                    placeholder="Sigla" />
            </div>
            <div class="field col-6">
                <label for="codigo">Código do curso</label>
                <input id="codigo" type="text" class="w-full" pInputText formControlName="codigo"
                    placeholder="Código do curso" />
            </div>
            <div class="field col-6">
                <label for="areaFormacao">Área de Conhecimento</label>
                <p-select id="areaFormacao" class="w-full" optionLabel="designacao" optionValue="id" [options]="areaFormacaoList" placeholder="Seleccione uma Área de Conhecimento"
                formControlName="areaFormacaoID"></p-select>
                <div *ngIf="cursoForm.get('areaFormacaoID')?.invalid && cursoForm.get('areaFormacaoID')?.touched" class="error-message">
                    Área de Conhecimento do curso é obrigatório
                </div>
            </div>
            <div class="field col-6">
                <label for="categoriaInstituicaoEnsinoID">Categoria do curso</label>
                <p-select id="categoriaInstituicaoEnsinoID" class="w-full" optionLabel="designacao" optionValue="id" [options]="categoriaOptions" placeholder="Seleccione a categoria"
                formControlName="categoriaInstituicaoEnsinoID"></p-select>
                <div *ngIf="cursoForm.get('categoriaInstituicaoEnsinoID')?.invalid && cursoForm.get('categoriaInstituicaoEnsinoID')?.touched" class="error-message">
                  Categoria do curso é obrigatório
                </div>
            </div>

            <div class="field col-12">
                <label for="nivelAcademico">Grau Académico</label>
                <p-select id="nivelAcademico" class="w-full" optionLabel="designacao" optionValue="id" [options]="nivelAcademico" placeholder="Seleccione o grau Académico"
                formControlName="nivelAcademico"></p-select>
                <div *ngIf="cursoForm.get('nivelAcademico')?.invalid && cursoForm.get('nivelAcademico')?.touched" class="error-message">
                  Nivel académico do curso é obrigatório
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <button pButton type="button" label="Cancelar" class="p-button-outlined" (click)="cancel()"></button>
            <button pButton type="submit" label="Adicionar" class="p-button-primary"></button>
        </div>
    </form>
</div>
<p-toast></p-toast>
<p-confirmdialog></p-confirmdialog>


-->

<p-toast></p-toast>